import { Tooltip, TooltipProps, styled, tooltipClasses } from '@mui/material';
import { ReactElement } from 'react';

interface IProps {
  text: string;
  position:
    | 'bottom'
    | 'left'
    | 'right'
    | 'top'
    | 'bottom-end'
    | 'bottom-start'
    | 'left-end'
    | 'left-start'
    | 'right-end'
    | 'right-start'
    | 'top-end'
    | 'top-start'
    | undefined;
  arrow: boolean;
  children: ReactElement;
}

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: '#424242',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.15)',
    borderRadius: 6,
    minHeight: 27,
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Poppins',
    fontWeight: 400,
    fontSize: 12,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
  },
}));

export const StyledTooltip: React.FC<IProps> = ({
  text,
  position,
  arrow,
  children,
}) => (
  <LightTooltip title={text} placement={position} arrow={arrow}>
    {children}
  </LightTooltip>
);
